<div class="empty-state d-flex flex-column align-items-center text-center">
  <div class="avatar-md mb-3">
    <span class="avatar-title rounded-circle bg-soft font-size-24 bg-{{ variant() }} text-{{ variant() }}">
      <i [class]="icon()"></i>
    </span>
  </div>

  <h5 class="font-size-16 mb-2">{{ title() }}</h5>

  @if (description()) {
    <p class="empty-state__description text-muted mb-0">{{ description() }}</p>
  }

  <div class="empty-state__actions">
    <ng-content></ng-content>
  </div>
</div>
